import { render, staticRenderFns } from "./DeleteResolutionPrivate.vue?vue&type=template&id=8b5f9a1e&"
import script from "./DeleteResolutionPrivate.vue?vue&type=script&lang=js&"
export * from "./DeleteResolutionPrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports